import imageUrlBuilder from '@sanity/image-url'
import {getSanityClient} from './sanityClient'

export function urlForImage(source) {
  const client = getSanityClient()
  if (!client || !source) return null
  return imageUrlBuilder(client).image(source)
}
